exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "\n.center[data-v-50fbd6aa] {\n    position: absolute;\n    left: 50%;\n    top: 50%;\n    transform: translate(-50%, -50%);\n}\ntextarea .fullscreen[data-v-50fbd6aa] {\n    overflow: hidden;\n    width: 200px;\n    height: 50px;\n    padding: 0;\n}\n\n", ""]);

